/** @jsxRuntime classic */ /** @jsx jsx */import{Flex}from'@bottlebooks/gatsby-design-system';import{jsx}from'theme-ui';/**
 * A panel inside of a dialog.
 * Shows the main content, with a gap.
 */export default function DialogMainPanel(_ref){var children=_ref.children;return jsx(Flex,{direction:"column",gap:2,sx:{paddingLeft:[0,3]}},children);}